/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FeedBackCreate = {
    properties: {
        rating: {
            type: 'number',
            isRequired: true,
        },
        content: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
